import { render, staticRenderFns } from "./HotelComponent.vue?vue&type=template&id=45de9fa4"
import script from "./HotelComponent.vue?vue&type=script&lang=js"
export * from "./HotelComponent.vue?vue&type=script&lang=js"
import style0 from "./HotelComponent.vue?vue&type=style&index=0&id=45de9fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports